import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {LanguageText} from '../models/language-text';


export const languageTextsActionTypes = {
  LOAD_FEE: type('[Language Text] Fee Load'),
  LOAD_GLOBAL: type('[Language Text] Global Load'),
  LOAD_REPLACEMENT: type('[Language Text] Replacement Load'),
  LOAD_FEE_SUCCESS: type('[Language Text] Load Fee Success'),
  LOAD_GLOBAL_SUCCESS: type('[Language Text] Load Global Success'),
  LOAD_REPLACEMENT_SUCCESS: type('[Language Text]  Replacement Load Success'),
  LOAD_FAIL: type('[Language Text] Load Fail'),
  CLEAR: type('[Language Text] Clear'),
  LANGUAGE_UPDATE: type('[Language ID] Update'),
  LANGUAGE_CLEAR: type('[Language ID] Clear'),
};

export class LoadLanguageTextsAction implements Action {
  readonly type = languageTextsActionTypes.LOAD_FEE;
  constructor(public payload?: string) {}
}
export class LanguageIdUpdateAction implements Action {
  readonly type = languageTextsActionTypes.LANGUAGE_UPDATE;
  constructor(public payload?: number) {}
}
export class LanguageIdClearAction implements Action {
  readonly type = languageTextsActionTypes.LANGUAGE_CLEAR;
  constructor(public payload?: number) {}
}
export class LoadLanguageTextSuccessAction implements Action {
  readonly type = languageTextsActionTypes.LOAD_FEE_SUCCESS;
  constructor(public payload?: LanguageText[]) {}
}
export class LoadGlobalLanguageTextsAction implements Action {
  readonly type = languageTextsActionTypes.LOAD_GLOBAL;
  constructor(public payload?: string) {}
}

export class LoadGlobalLanguageTextSuccessAction implements Action {
  readonly type = languageTextsActionTypes.LOAD_GLOBAL_SUCCESS;
  constructor(public payload?: LanguageText[]) {}
}
export class LoadReplacementLanguageTextsAction implements Action {
  readonly type = languageTextsActionTypes.LOAD_REPLACEMENT;
  constructor(public payload?: string) {}
}

export class LoadReplacementLanguageTextSuccessAction implements Action {
  readonly type = languageTextsActionTypes.LOAD_REPLACEMENT_SUCCESS;
  constructor(public payload?: LanguageText[]) {
  }
}

export class LoadLanguageTextFailAction implements Action {
  readonly type = languageTextsActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class LanguageTextClearAction implements Action {
  readonly type = languageTextsActionTypes.CLEAR;
  constructor() {}
}

